export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          手机访问
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 border border-secondary-200/60 rounded-2xl p-8 md:p-10 text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-primary-100 rounded-2xl">
              <i className="ri-smartphone-line text-4xl text-primary-600"></i>
            </div>
            <h3 className="text-xl font-bold text-foreground-900 mb-3 font-heading">
              随时随地，畅快吃瓜
            </h3>
            <p className="text-foreground-600 mb-6 leading-relaxed">
              五一黑料网支持手机浏览器直接访问，无需下载 APP。打开手机浏览器输入五一黑料入口地址，即可随时随地浏览最新黑料吃瓜、今日黑料和瓜田爆料内幕。页面自适应手机屏幕，浏览体验流畅丝滑。
            </p>
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-primary-500 text-background-50 rounded-xl font-semibold whitespace-nowrap">
              <i className="ri-qr-scan-line text-xl"></i>
              <span>手机扫码访问最新入口</span>
            </div>
            <p className="text-xs text-foreground-400 mt-3">
              温馨提示：建议收藏本站，确保访问畅通
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}